module.exports = __webpack_public_path__ + "static/img/cont33_05.13ac6fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont33_05.jpg
// module id = I/a+
// module chunks = 0